import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import TDesign from 'tdesign-vue';
import 'tdesign-vue/es/style/index.css';
import {
  Row,
  Col,
  Tabs,
  TabPane,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Radio,
  RadioGroup,
  RadioButton,
  Icon,
  Carousel,
  Cascader,
  Popover,
  CascaderPanel,
  CarouselItem
} from 'element-ui';
import router from './router'
import axios from 'axios'
// 翻译网页
import translate from 'i18n-jsautotranslate'
translate.setUseVersion2() //设置使用v2.x 版本
translate.selectLanguageTag.show = false //是否显示切换栏
translate.language.setLocal('english');
translate.ignore.class.push('no-translation');
translate.listener.start() //监控页面动态渲染的文本进行自动翻译
Vue.prototype.$translate = translate
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
Vue.use(TDesign);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Icon);
Vue.use(Popover);
Vue.use(Cascader);
Vue.use(CascaderPanel);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Col);
Vue.use(Row);
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
